import { TableRow } from "../utils/tables-metadata";
import {
  getFeaturedNotes,
  getFeaturedConditions,
  getFeaturedImaging,
  getFeaturedLabs,
  getFeaturedQualityScreening,
  getFeaturedScreenings,
} from "./rules";

export type FeaturedSubCategory = {
  readonly subCategory: string;
  readonly tableType: string;
  readonly getRows: (data: TableRow[]) => TableRow[];
};

export type FeaturedCategory = {
  readonly category: string;
  readonly subCategories: readonly FeaturedSubCategory[];
};

export type FeaturedSubCategoryData = {
  subCategory: string;
  rows: TableRow[];
  originalTableType: string;
};

export type FeaturedCategoryData = {
  category: string;
  subCategories: FeaturedSubCategoryData[];
};

/**
 * Get all featured category configurations
 */
function getFeaturedCategoryConfigs(): FeaturedCategory[] {
  return [
    getFeaturedConditions(),
    getFeaturedScreenings(),
    getFeaturedLabs(),
    getFeaturedQualityScreening(),
    getFeaturedImaging(),
    getFeaturedNotes(),
  ];
}

/**
 * Generate featured categories with actual data by applying rules to table data
 */
export function getFeaturedCategories(
  rowsByCategory: Map<string, TableRow[]>
): FeaturedCategoryData[] {
  return getFeaturedCategoryConfigs()
    .map(categoryConfig => {
      const subCategoriesWithData = categoryConfig.subCategories
        .map(subCategory => {
          const rows = rowsByCategory.get(subCategory.tableType);
          if (!rows || rows.length === 0) return undefined;

          const filteredRows = subCategory.getRows(rows);
          if (filteredRows.length === 0) return undefined;

          return {
            subCategory: subCategory.subCategory,
            rows: filteredRows,
            originalTableType: subCategory.tableType,
          };
        })
        .filter((sub): sub is FeaturedSubCategoryData => sub !== undefined);

      return {
        category: categoryConfig.category,
        subCategories: subCategoriesWithData,
      };
    })
    .filter(cat => cat.subCategories.length > 0);
}
